module.exports = __webpack_public_path__ + "static/media/Image_not_available.b36433c9.png";